export const isNullable = (value) => {
    return value === null || value === undefined;
};
export const isNullableOrZero = (value) => {
    return value === null || value === undefined || value === 0;
};
export const toFiniteNumber = (value, fallback = 0) => {
    if (value === null || value === undefined || value === '') {
        return fallback;
    }
    const parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};
export const nonNullable = (value) => {
    return !isNullable(value);
};
export const isEmpty = (value) => {
    return isNullable(value) || value.trim().length === 0;
};
export const isNotEmpty = (value) => {
    return !isEmpty(value);
};
export const trimToUndefined = (value) => {
    if (isEmpty(value))
        return undefined;
    return value.trim();
};
export const not = (predicate) => {
    return (value) => !predicate(value);
};
export const asyncMap = (callback) => {
    return async (valuePromise) => {
        return await callback(await valuePromise);
    };
};
export const aggregateBy = (keyGetter) => {
    return (acc, value) => {
        const key = keyGetter(value);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(value);
        return acc;
    };
};
export const ascendingBy = (keyGetter) => {
    return (a, b) => {
        const aKey = keyGetter(a);
        const bKey = keyGetter(b);
        return aKey - bKey;
    };
};
export const descendingBy = (keyGetter) => {
    return (a, b) => {
        const aKey = keyGetter(a);
        const bKey = keyGetter(b);
        return bKey - aKey;
    };
};
export const uniques = (array) => {
    return [...new Set(array)];
};
//# sourceMappingURL=TypescriptService.js.map